import { render, staticRenderFns } from "./seedXq.vue?vue&type=template&id=747de02a&scoped=true"
import script from "./seedXq.vue?vue&type=script&lang=js"
export * from "./seedXq.vue?vue&type=script&lang=js"
import style0 from "./seedXq.vue?vue&type=style&index=0&id=747de02a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747de02a",
  null
  
)

export default component.exports